export enum SubmissionTask {
  ReviewSubmission = 'ReviewSubmission',
  RenewalDocs = 'RenewalDocs',
  ExpiringPolicies = 'ExpiringPolicies',
  LossRuns = 'LossRuns',
}
